import {Directive, EventEmitter, HostBinding, HostListener, Input, Output} from '@angular/core';
import {SortDirection} from '../_constants/types';

const rotate: {[key: string]: SortDirection} = {asc: 'desc', desc: '', '': 'asc'};

export interface SortEvent {
  column: string;
  direction: SortDirection;
}

/**
 * A directive to help make tables sortable by column
 */
@Directive({ 
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'th[appSortable]'})
export class SortableDirective {

  @Input() appSortable: string;
  @Output() sort = new EventEmitter<SortEvent>();

  @HostBinding('class') direction: SortDirection = '';

  @HostListener('click')
  rotate() {
    this.direction = rotate[this.direction];
    console.debug(`sorting column ${this.appSortable} ${this.direction}`);
    this.sort.emit({column: this.appSortable, direction: this.direction});
  }

}
